import axios from '../../../utils/AxiosUtils';
import i18n from '../../../i18next';

import MessageUtils from "../../../utils/MessageUtils";
import { 
    LOADING, 
    LOAD_ALL_ALLERGENS_SUCCESS, 
    LOAD_ALL_DIETARY_INFO_SUCCESS,
    LOAD_ALL_NUTRIENTS_SUCCESS } from '../../types';

export const loadAllergens = () => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/allergen`;

        axios().get(url)
            .then(response => loadAllergensSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:allergensAndDietaryActions.problemAllergens')));
    }
}

const loadAllergensSuccess = (dispatch, response) => {
    dispatch({ type: LOAD_ALL_ALLERGENS_SUCCESS, payload: response.data });
    dispatch({ type: LOADING, payload: false });
}

export const loadDietaryInfo = () => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/dietary-info`;

        axios().get(url)
            .then(response => loadDietaryInfoSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:allergensAndDietaryActions.problemDietary')))
    }
}

const loadDietaryInfoSuccess = (dispatch, response) => {
    dispatch({ type: LOAD_ALL_DIETARY_INFO_SUCCESS, payload: response.data })
    dispatch({ type: LOADING, payload: false });
}

export const loadNutrients = () => {
    return (dispatch) => {
        const url = `/nutrition`;

        axios().get(url)
            .then(response => loadNutrientsSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:allergensAndDietaryActions.problemNutri')))
    }
}

const loadNutrientsSuccess = (dispatch, response) => {
    dispatch({ type: LOAD_ALL_NUTRIENTS_SUCCESS, payload: response.data });
}


// WEBPACK FOOTER //
// ./src/actions/restaurants/posmenu/AllergensAndDietaryInfo.js